<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .oauth-content {
    display: flex;
    align-items: center;
    gap: utils.in_rem(12px);
    .oauth-image {
      height: utils.in_rem(16px);
      width: utils.in_rem(16px);
    }
    .text {
      color: colors.get(textLighterBlack);
    }
  }
</style>

<script>
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import { signUp } from "../../../../../src/svelte/api/signup";

  let { imageSrc, provider } = $props();

  // Capture UTM params from marketing site.
  const params = new URLSearchParams(window.location.search);
  const utm = {
    source: params.get("utm_source") || "",
    medium: params.get("utm_medium") || "",
    campaign: params.get("utm_campaign") || "",
    content: params.get("utm_content") || "",
    term: params.get("utm_term") || "",
    gl: params.get("_gl") || "",
  };

  const onclick = async () => {
    const res = await signUp({ provider, utm });
    window.location.href = res.url;
  };
</script>

<Button
  {onclick}
  kind="tertiary"
  size="large"
  style="width:280px;height:2.75rem;"
>
  <div class="oauth-content">
    <img src={imageSrc} alt="Sign up with {provider}" class="oauth-image" />
    <span class="text">
      Sign up with {provider === "gcp" ? "Google" : "Microsoft"}
    </span>
  </div>
</Button>
